<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Carreta">
          <b-form @submit.prevent="send">
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Placa</label>
                <input type="text" v-model="cart.plate" class="form-control">
              </b-col>
            </b-row>
            <div slot="footer">
              <b-button type="submit" variant="primary">Enviar</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import constants from "@/constants";
import api from "@/helpers/api";

export default {
  props: ["cart_id"],
  data() {
    return {
      cart: {},
      id: this.$route.params.id,
      address: ""
    };
  },
  mounted() {
    if (this.cart_id) {
      api.get(`/cart/${this.id}`).then(response => {
        this.cart = response.cart;
      });
    }
  },
  methods: {
    send() {
      if (this.cart_id) {
        api.put(`/cart/${this.id}`, this.cart).then(response => {
          if (response.success) {
            this.$toastr.success(
              `La empresa ${this.cart.plate} fue modificada exitosamente.`,
              "Actualizar Carreta",
              { positionClass: "toast-top-center", closeButton: true }
            );
            this.$router.push({
              path: `/cart/list`
            });
          } else alert("Creación fallida");
        });
      } else {
        api.post("/cart", this.cart).then(response => {
          if (response.success) {
            this.$toastr.success(
              `La carreta ${this.cart.plate} fue creada exitosamente.`,
              "Crear Carreta",
              { positionClass: "toast-top-center", closeButton: true }
            );
            this.$router.push({
              path: `/cart/list`
            });
          } else alert("Creación fallida", response.message);
        });
      }
    }
  }
};
</script>
